import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'ExpandToggleButton',
  props: {
    value: { type: Boolean },
    collapsedText: null,
    expandedText: null
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({ (e: 'input', value: boolean): void }), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value?: boolean;
  collapsedText?: string;
  expandedText?: string;
};




return { __sfc: true,props, emit }
}

})